import { SET_SUCURSAL } from "../constanst";

export function setSucursal(sucursal) {
    localStorage.setItem('sucursal', JSON.stringify(sucursal));
    return async(dispatch) => {
        try {            
            dispatch({
                type: SET_SUCURSAL,
                payload: sucursal,
            });

        } catch (error) {
            console.log(error);
        }

    }
}
